import { atom, useAtom } from 'jotai'

import { InspectionGroupStatus } from '@/constant/qsf'

export const activeTileInspectionAtom: any = atom(InspectionGroupStatus.ACTIVE)

export const defaultGeneratingReportAtom = atom({})

export interface GeneratingReportType {
  isGenerating?: boolean
  progress?: number
}

const reportDataAtom = atom<GeneratingReportType>({
  isGenerating: false,
  progress: 0, // TODO Implement downloading progress when API done
})

export const useGeneratingReportAtom = () => {
  const [generatingReportAtom, setGeneratingReportAtom] =
    useAtom<GeneratingReportType>(reportDataAtom)

  return {
    generatingReportAtom,
    setGeneratingReportAtom,
    resetGeneratingReportAtom: () =>
      setGeneratingReportAtom({
        isGenerating: false,
        progress: 0,
      }), // Optional reset function
  }
}
